import T from './translate/T'

T.addSubLanguages({
    'en-US': () => import('./languages/en-us.json'),
    'pt-BR': () => import('./languages/pt-br.json'),
    'es': () => import('./languages/es.json'),
})



// WEBPACK FOOTER //
// ./src/SPRINTA/__autoload.js